import { render, staticRenderFns } from "./EvanCell.vue?vue&type=template&id=63978c1c"
import script from "./EvanCell.vue?vue&type=script&lang=js"
export * from "./EvanCell.vue?vue&type=script&lang=js"
import style0 from "./EvanCell.vue?vue&type=style&index=0&id=63978c1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports